import { motion } from "framer-motion";
import SectionLabel from "./SectionLabel";

const REASONS = [
  "End-to-end ownership - not fragmented vendors.",
  "Strong execution capability - not just concepts.",
  "Experience across branding, retail, and industrial sectors.",
  "Ability to scale across multiple locations.",
  "A balance of creativity and practical implementation.",
];

const WhyUprcse = () => {
  return (
    <section
      data-testid="why-uprcse"
      className="relative py-24 md:py-32 border-t-2 border-black"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <SectionLabel className="mb-6" testid="label-why">
              [ 06 ] - WHY UPRCSE
            </SectionLabel>
            <h2
              className="font-archivo font-black h-tighter text-4xl md:text-5xl lg:text-6xl text-black"
              style={{ fontFamily: "Archivo, sans-serif" }}
            >
              We don't deliver pieces.
              <br />
              <span className="text-[#AE519F]">We build systems.</span>
            </h2>
            <p
              className="mt-8 text-black/70 text-base md:text-lg max-w-md"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              If your business needs more than design - if it needs structured
              branding with real-world execution - UPRCSE is built for that.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-px bg-black/30">
              {REASONS.map((r, i) => (
                <motion.div
                  key={r}
                  initial={{ opacity: 0, x: 18 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.55, delay: i * 0.08 }}
                  viewport={{ once: true }}
                  className="bg-[#CCD6DC] p-6 md:p-7 grid grid-cols-12 items-center gap-5 group hover:bg-[#FFBBFF]/40 transition-colors"
                >
                  <div className="col-span-2 md:col-span-1 mono-label">
                    {`R${i + 1}`}
                  </div>
                  <div className="col-span-9 md:col-span-10">
                    <div
                      className="text-black text-xl md:text-2xl group-hover:text-[#AE519F] transition-colors"
                      style={{
                        fontFamily: "Archivo, sans-serif",
                        fontWeight: 700,
                        letterSpacing: "-0.015em",
                        lineHeight: 1.15,
                      }}
                    >
                      {r}
                    </div>
                  </div>
                  <div className="col-span-1 flex justify-end">
                    <span className="h-px w-6 bg-black group-hover:bg-[#AE519F] transition-colors" />
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUprcse;
